import axios from 'axios';

axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN': window.csrf_token
};

axios.interceptors.response.use(function (successRes){
    console.log('successRes',successRes)
}, function (err) {
    return new Promise(function (resolve, reject) {

        console.error(err)
        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
            //   this.$store.dispatch(logout)
        }
        throw err;
    });
});

export const API = axios.create({
    baseURL_Config: process.env.MIX_APP_URL,
    baseURL: window.location.protocol + '//' + window.location.host,
    withCredentials: true
})
